module.exports = {
  isBuyOneGetOne(product) {
    return product.offer === 'Buy One Get One Free';
  },
};
